import { useEffect } from "react";

/** Injects a JSON-LD structured-data script into <head> for the life of the component. */
const JsonLd = ({ id, data }) => {
  const json = JSON.stringify(data);
  useEffect(() => {
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = `jsonld-${id}`;
    el.text = json;
    document.head.appendChild(el);
    return () => {
      document.getElementById(`jsonld-${id}`)?.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, json]);
  return null;
};

export default JsonLd;
